import * as R from 'ramda'
import { SET_ENTITIES } from 'actions'

const cardReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_ENTITIES: {
      return R.merge(state, action.entities.card)
    }
    default:
      return state
  }
}

export default cardReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/card.js